import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { cloneDeep, isEmpty } from 'lodash';
import { round } from 'mathjs';

import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moLeaveRate from './store';
import PDF from '../../component/pdf';
import Title from '../../component/title';
import HeadPdf from '../../component/head-pdf';
import FootPdf from '../../component/foot-pdf';
import moIndex from '../../store/index';
import IndicatorTable from '../indicator-table';
import LeaveTable from './leave-table';
import Table from './table';
import Explain from './explain';
import ExplainPDF from './explain-pdf';

interface IProps {}
interface IState {}

const TablePDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { xData, tableHead, tableLeft, tableRight } = moLeaveRate;

  const calcLog = () => {
    const leftArr: any[] = cloneDeep(tableLeft.slice(25));
    const rightArr: any[] = cloneDeep(tableRight.slice(25));
    const text: any[] = [];
    for (let i = 0; i < Math.ceil(leftArr.length / 25); i += 1) {
      const leftData = leftArr.slice(25 * i + 25 * i, 25 * i + 25 * i + 25);
      const rightData = rightArr.slice(25 * i + 25 * i, 25 * i + 25 * i + 25);
      text.push(
        <PDF key={i}>
          <section className="industry-leave-pdf_1500">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-1500">
              <section className="title-1001">
                <Title title="行业离职率" bigTitle="人力指标" />
              </section>

              <LeaveTable tableHead={tableHead} tableLeft={leftData} tableRight={rightData} />

              {i === Math.floor(leftArr.length / 25) ? (
                <>
                  {tableLeft.length % 25 <= 20 ? <Explain /> : null}
                </>
              ) : null}
            </section>
            <FootPdf />
          </section>
        </PDF>,
      );
    }
    return text;
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <Table />
      {tableLeft.length > 25 ? calcLog() : null}
      {tableLeft.length % 25 > 20 ? <ExplainPDF /> : null}
    </>
  );
};

export default observer(TablePDF);
